import {envConfig} from '@/utils';
import {Event, SportsListItem, PeriodScore} from './service';
import {SportsItem} from './components/swiper-card';
import dayjs from 'dayjs';
import {GRPeriodScore, IHomeSportsCardItem} from '../home/home.type';

// export function getSportsCategories(
//   sportsName: string,
//   category: SportsCategory,
//   count: number = 1,
// ): SportsItem[] {
//   const categoryName = category.Name.en;
//   const list: SportsItem[] = [];
//   for (let i = 0; i < category.Tournaments.length; i++) {
//     const tour = category.Tournaments[i];
//     const tourName = tour.Name.en;
//     for (let j = 0; j < tour.Events.length; j++) {
//       const event = tour.Events[j];
//       const versus = event.Competitors.map(item => ({
//         teamName: item.Name.en,
//         teamPic: `${envConfig.gr8IframeUrl}taxonomyicons/competitors/${item.Id}-164w`,
//       }));
//       const matchInfo = getMatchInfo(sportsName, event);
//       list.push({
//         title: `${tourName}. ${categoryName}. ${sportsName}`,
//         // 必然是直播赛事，所以这边不展示这些小部件
//         hasLiveMatch: false,
//         vs: versus,
//         ...matchInfo,
//       });
//     }
//   }
//   return list.slice(0, count);
// }

export const typeNamesMap = {
  ICC: 'ODI. ICC Champions Trophy',
  WPL: 'Women. Premier League',
};

const allSportFullPeriodMap: Record<string, number> = {
  Basketball: 8,
  Football: 4,
  Volleyball: 1,
  CyberSport: 1,
  Cricket: 1,
};

function getSlug(url: string) {
  const urlArr = url.split('/');
  for (let i = 0; i < urlArr.length; i++) {
    if (urlArr[i] === 'events') {
      return urlArr[i + 1];
    }
  }
  return '';
}

function getLeagueTime(startTime: string | number) {
  const leagueDay = dayjs(startTime).diff(dayjs(), 'day');
  let leagueTime = '';
  if (leagueDay < 1) {
    leagueTime = 'Today, ' + dayjs(startTime).format('HH:mm');
  } else if (leagueDay < 2) {
    leagueTime = 'Tomorrow, ' + dayjs(startTime).format('HH:mm');
  } else {
    leagueTime = dayjs(startTime).format('MMMM D, HH:mm');
  }
  return leagueTime;
}

function getCricketSubScore(matchPeriodAll?: PeriodScore[]) {
  if (!matchPeriodAll || !matchPeriodAll.length) {
    return;
  }
  const runningScore = matchPeriodAll.find(
    item => item.Type === 'Runs' && item.SubPeriod == null,
  );
  const wicketScore = matchPeriodAll.find(item => item.Type === 'Wickets');
  const runningArr = runningScore?.Score.split('-');
  const wicketArr = wicketScore ? wicketScore.Score.split('-') : null;
  return `${runningArr?.[0] || '0'}${
    wicketArr ? `/${wicketArr[0] || '0'}` : ''
  }:${runningArr?.[1] || '0'}${wicketArr ? `/${wicketArr[1] || '0'}` : ''}`;
}

function getGRCricketSubScore(matchPeriodAll?: GRPeriodScore[]) {
  if (!matchPeriodAll || !matchPeriodAll.length) {
    return;
  }
  const runningScore = matchPeriodAll.find(item => item.type === 'Runs');
  const wicketScore = matchPeriodAll.find(item => item.type === 'Wickets');
  const runningArr = runningScore?.score.split('-');
  const wicketArr = wicketScore ? wicketScore.score.split('-') : null;
  return `${runningArr?.[0] || '0'}${
    wicketArr ? `/${wicketArr[0] || '0'}` : ''
  }:${runningArr?.[1] || '0'}${wicketArr ? `/${wicketArr[1] || '0'}` : ''}`;
}

function getMatchInfo(
  sportsName: string,
  event: Event,
): Omit<SportsItem, 'title' | 'vs'> {
  const market = event.Markets[0];
  const periodName = market.PeriodName.en;
  const matchingPeriodId = market.MarketKey.Period;
  const fullPeriodId = allSportFullPeriodMap[sportsName] || 1;
  const periods = event.PeriodScores;
  const urlFirst = Object.values(event.URL)[0];
  const slug = getSlug(urlFirst);

  const fullPeriod = periods?.find(item => item.Period === fullPeriodId);
  const mainScore = fullPeriod?.Score.split('-').join(':') || '0:0';
  const marketList = market.Outcomes.map((item, index, arr) => ({
    price: item.Price + '',
    outcomeName:
      arr.length === 2
        ? index + 1 + ''
        : arr.length === 3
        ? ['1', 'x', '2'][index]
        : item.OutcomeName.en,
  }));
  let leagueTime = getLeagueTime(event.StartTime);
  if (sportsName === 'Cricket') {
    const matchPeriod5All = periods?.filter(item => item.Period === 5);
    const matchPeriod6All = periods?.filter(item => item.Period === 6);
    let vsSub1Score: string | undefined;
    if (matchPeriod6All?.length) {
      vsSub1Score = getCricketSubScore(matchPeriod6All);
    } else if (matchPeriod5All?.length) {
      vsSub1Score = getCricketSubScore(matchPeriod5All);
    }

    return {
      vsType: matchPeriod6All?.length ? 'Innings 2' : 'Innings 1',
      vsScore: mainScore,
      vsRedScore: vsSub1Score,
      leagueTime: leagueTime,
      leagueTimeBase: dayjs(event.StartTime).unix() * 1000,
      isLive: event.Stage === 'Live',
      uri: `/events/${slug}`,
      marketList: marketList,
    };
  }
  const matchPeriod = periods?.find(item => item.Period === matchingPeriodId);

  return {
    vsType: periodName,
    vsScore: mainScore,
    isLive: event.Stage === 'Live',
    vsRedScore:
      matchingPeriodId !== fullPeriodId &&
      matchPeriod &&
      fullPeriod &&
      matchPeriod?.Score !== fullPeriod?.Score
        ? matchPeriod?.Score.split('-').join(':')
        : undefined,
    leagueTime: leagueTime,
    leagueTimeBase: dayjs(event.StartTime).unix() * 1000,
    uri: `/events/${slug}`,
    marketList,
  };
}

export function getMatchScores(game: IHomeSportsCardItem) {
  if (game.grEventsStage !== 'Live') {
    return {
      vsScore: '0:0',
      vsRedScore: '0:0',
      vsType: '',
    };
  }
  const sportsName = game.grSportName;
  const fullPeriodId = allSportFullPeriodMap[sportsName] || 1;
  const fullPeriod = game.grPeriodScores?.find(
    item => item.period === fullPeriodId,
  );

  const mainScore = fullPeriod?.score.split('-').join(':') || '0:0';

  if (sportsName === 'Cricket') {
    const matchPeriod5All = game.grPeriodScores?.filter(
      item => item.period === 5,
    );
    const matchPeriod6All = game.grPeriodScores?.filter(
      item => item.period === 6,
    );
    let vsSub1Score: string | undefined;
    if (matchPeriod6All?.length) {
      vsSub1Score = getGRCricketSubScore(matchPeriod6All);
    } else if (matchPeriod5All?.length) {
      vsSub1Score = getGRCricketSubScore(matchPeriod5All);
    }
    return {
      vsScore: mainScore,
      vsRedScore: vsSub1Score,
      vsType: matchPeriod6All?.length ? 'Innings 2' : 'Innings 1',
    };
  }
  const matchingPeriodId = game.grMarketKeyPeriod || fullPeriodId;
  const matchPeriod = game.grPeriodScores?.find(
    item => item.period === matchingPeriodId,
  );
  const vsType = game.grMarketsPeriodName;

  return {
    vsScore: mainScore,
    vsRedScore:
      matchingPeriodId !== fullPeriodId &&
      matchPeriod &&
      fullPeriod &&
      matchPeriod?.score !== fullPeriod?.score
        ? matchPeriod?.score.split('-').join(':')
        : undefined,
    vsType,
  };
}

export const sportsIconMap: Record<string, string> = {
  Basketball: require('@/assets/icons/sports/basketball.webp'),
  Football: require('@/assets/icons/sports/football.webp'),
  Volleyball: require('@/assets/icons/sports/volleyball.webp'),
  CyberSport: require('@/assets/icons/sports/cybersport.webp'),
  Cricket: require('@/assets/icons/sports/cricket.webp'),
  Kabaddi: require('@/assets/icons/sports/kabaddi.webp'),
};

// export function convertToSportsCategory(sportsListItem: SportsListItem) {
//   const {Sport, Categories} = sportsListItem;
//   return {
//     title: Sport,
//     icon: sportsIconMap[Sport],
//     type: Sport as SportsType,
//     list: Categories.reduce<SportsItem[]>((all, item) => {
//       return [...all, ...getSportsCategories(Sport, item, 5)];
//     }, []),
//   };
// }

export const filterCategory = (name: string) => {
  if (name.toLowerCase().includes('kabaddi')) {
    return true;
  }
  return (
    !name.toLowerCase().includes('virtual') &&
    name.toLowerCase() !== 'simulated reality league' &&
    name.toLowerCase() !== 'ecricket'
  );
};

// export function convertToSportsSwiperItemList(
//   sportsListItemArr: SportsListItem[] = [],
// ) {
//   let _sportsListItemArr = Array.from(sportsListItemArr);
//   let indexList = Array.from({length: _sportsListItemArr.length}, () => 0);
//   let itemList: SportSwiperItemProps[] = [];
//   while (true) {
//     const hasNext = indexList.length > 0;
//     if (!hasNext) {
//       return itemList;
//     }
//     const checkIndex = Math.floor(Math.random() * indexList.length);
//     const sportsListItem = _sportsListItemArr[checkIndex];
//     const {Sport, Categories} = sportsListItem;
//     const item = Categories[indexList[checkIndex]];
//     if (filterCategory(item.Name.en)) {
//       const sportsItemList = getSportsCategories(Sport, item, 10000);
//       sportsItemList.forEach(_item => {
//         itemList.push({
//           category: {
//             title: Sport,
//             type: Sport as SportsType,
//             icon: sportsIconMap[Sport],
//           },
//           item: _item,
//         });
//       });
//     }

//     indexList[checkIndex]++;
//     if (indexList[checkIndex] >= Categories.length) {
//       indexList.splice(checkIndex, 1);
//       _sportsListItemArr.splice(checkIndex, 1);
//     }
//   }
// }

function toSportsCardItem(sportItem: SportsListItem) {
  const events: SportsItem[] = [];
  sportItem.Categories.forEach(category => {
    category.Tournaments.forEach(tournament => {
      tournament.Events.forEach(event => {
        // 虚拟体育不显示
        if (!filterCategory(category.Name.en)) {
          return;
        }
        console.log('event', event);
        events.push({
          title: `${tournament.Name.en}. ${category.Name.en}. ${sportItem.Sport}`,
          vs: event.Competitors.map(competitor => ({
            teamName: competitor.Name.en,
            teamPic: `${envConfig.gr8IframeUrl}taxonomyicons/competitors/${competitor.Id}-164w`,
          })),
          sport: sportItem.Sport,
          completeEventId: `${event.Id}-${tournament.Id}-${category.Id}-${sportItem.SportId}`,
          ...getMatchInfo(sportItem.Sport, event),
        });
      });
    });
  });
  return events;
}

export function convertToSportsItemMap(allSports: SportsListItem[] = []) {
  // key 体育id value 对应体育卡片
  const map: Record<string, SportsItem> = {};
  const processItem = (item: SportsListItem) => {
    toSportsCardItem(item).forEach(_item => {
      if (!_item.sport || !_item.completeEventId) {
        return;
      }
      if (!map[_item.completeEventId]) {
        map[_item.completeEventId] = _item;
      } else {
        // 如果是live赛事则覆盖原先的
        if (_item.isLive) {
          map[_item.completeEventId] = _item;
        }
      }
    });
  };
  allSports.forEach(processItem);
  return map;
}

const timeSort = (a: SportsItem, b: SportsItem) => {
  const aTime = dayjs(a.leagueTimeBase).unix();
  const bTime = dayjs(b.leagueTimeBase).unix();
  return aTime - bTime;
};

export function defaultSportByFloorData(
  sportsMap: Record<string, SportsItem>,
  tagName: string,
  name: string,
) {
  // 检查tagname后缀是否为体育
  if (!tagName.endsWith('_sport')) {
    return [];
  }
  const sport = tagName.split('_')[0];
  // 优先判断具有特定tagname的，单独处理
  if (typeNamesMap[sport as keyof typeof typeNamesMap]) {
    const sportList = Object.values(sportsMap).filter(
      item =>
        item.title
          ?.toLowerCase()
          .includes(typeNamesMap[sport as keyof typeof typeNamesMap]) &&
        item.sport === 'Cricket',
    );
    if (sportList.length > 0) {
      return sportList.sort(timeSort);
    }
    return [];
  }
  // 判断体育类型处理
  const sportList = Object.values(sportsMap).filter(
    item => item.sport?.toLowerCase() === sport.toLowerCase(),
  );
  if (sportList.length > 0) {
    return sportList.sort(timeSort);
  }
  // 不属于体育类型，认为是体育名称内容，默认具名体育应有Cricket筛选
  const sportNameList = Object.values(sportsMap).filter(
    item =>
      item.title.toLowerCase().includes(name.toLowerCase()) &&
      item.sport === 'Cricket',
  );
  if (sportNameList.length > 0) {
    return sportNameList.sort(timeSort);
  }
  return [];
}

export function toSportItem(game: IHomeSportsCardItem): SportsItem {
  const id = `${game.grEventsId}-${game.grTournamentsId}-${game.grCategoriesId}-${game.grSportId}`;
  const outcomes = game.grOutcomes;
  const slug = getSlug(game.grEventsUrl);
  return {
    title: `${game.grTournamentsName}. ${game.grCategoriesName}. ${game.grSportName}`,
    vs: game.grCompetitors.map(item => ({
      teamName: item.competitorName,
      teamPic: `${envConfig.gr8IframeUrl}taxonomyicons/competitors/${item.competitorId}-164w`,
    })),
    leagueTime: getLeagueTime(+game.grEventsStartTimeUnixFormat * 1000),
    leagueTimeBase: +game.grEventsStartTimeUnixFormat * 1000,
    completeEventId: id,
    sport: game.grSportName,
    isLive: game.grEventsStage === 'Live',
    marketList: outcomes.map((item, index, arr) => ({
      price: item.price + '',
      outcomeName:
        arr.length === 2
          ? index + 1 + ''
          : arr.length === 3
          ? ['1', 'x', '2'][index]
          : item.outcomeName,
    })),
    uri: `/events/${slug}`,
    ...getMatchScores(game),
  };
}
